import { MAX_CHARGE_DAYS } from "@/lib/constant";
import { PriceResultAllExtra } from "@/lib/type";

export const extraPriceWithCountOnly = (extra: PriceResultAllExtra): number => {
  return (extra.value / 100) * (100 + extra.tax_rate) * (extra.count || 1); // Use count only, no rental days involved
};

export const extraPriceWithRentalDays = (
  extra: PriceResultAllExtra,
  rentalDays: number
): number => {
  // const maxDays = MAX_CHARGE_DAYS[extra.extra_id.toUpperCase()] || rentalDays;
  // const cappedDays = Math.min(rentalDays, maxDays);
  const extraValue =
    (extra.value / 100) *
    (100 + extra.tax_rate) *
    (rentalDays || 0) *
    (extra.count || 1);
  return extraValue;
};
